import * as React from 'react'

export const IconLinkedin = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)'>
      <path
        d='M20.5 1.5H2.453C1.656 1.5 1 2.203 1 3.047V21c0 .844.656 1.5 1.453 1.5H20.5c.797 0 1.5-.656 1.5-1.5V3.047c0-.844-.703-1.547-1.5-1.547Zm-13.172 18H4.234V9.516h3.094V19.5ZM5.781 8.11c-1.031 0-1.828-.797-1.828-1.782A1.83 1.83 0 0 1 5.781 4.5c.985 0 1.782.844 1.782 1.828A1.78 1.78 0 0 1 5.78 8.11ZM19 19.5h-3.14v-4.875c0-1.125 0-2.625-1.594-2.625-1.641 0-1.875 1.266-1.875 2.578V19.5H9.297V9.516h2.953v1.359h.047c.422-.797 1.453-1.64 2.953-1.64 3.14 0 3.75 2.109 3.75 4.78V19.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
